// Quem administra é decidido pelo PAPEL do perfil, nunca pelo id dele.
//
// Até a migration 2026_08_29_120000 da API, os perfis eram um catálogo global
// e "Administrador" era sempre o id 1 — então `profile_id === 1` funcionava,
// por acidente de ordem de inserção. Com um perfil por tenant, o
// "Administrador" de cada empresa tem id próprio, e essa comparação passa a
// negar acesso justamente a quem tem direito: o administrador do cliente.
//
// Existe num arquivo só porque a checagem estava repetida em 8 telas. Uma
// regra de autorização duplicada é uma regra que vai divergir.

/** O usuário tem perfil com papel de administrador do próprio tenant. */
export const hasAdminProfile = (user) => {
  if (!user) return false;

  // Sessão iniciada antes desta mudança ainda não tem `profile_role` guardado.
  // Nesse caso volta ao critério antigo, que continua correto para o tenant 1
  // — e não gera falso positivo para os demais, já que o perfil deles nunca é
  // o id 1. Some sozinho no próximo login.
  if (user.profile_role === undefined || user.profile_role === null) {
    return Number(user.profile_id) === 1;
  }

  return user.profile_role === 'admin';
};

/** Administrador OU líder. */
export const hasLeaderProfile = (user) => {
  if (!user) return false;

  if (user.profile_role === undefined || user.profile_role === null) {
    return [1, 2].includes(Number(user.profile_id));
  }

  return ['admin', 'leader'].includes(user.profile_role);
};
